<template>
    <span class="sportsSwitch-sportItem-tag sportsSwitch-sportItem-tag_live">
        {{ getTranslationBySite('live') }}
    </span>
</template>

<script lang="ts" setup>
    import { getTranslationBySite } from '@/libraries/helpers/i18nHelper';
</script>

<style scoped lang="scss">
@import "@/scss/components/sportListItemTag";
</style>
